module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-root"
  }, [_c('background'), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('logo'), _vm._v(" "), _c('div', {
    staticClass: "text-box"
  }, [_c('h1', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.message.name))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_c('animate-text', {
    attrs: {
      "value": _vm.message.descriptions,
      "time": 1000
    }
  })], 1), _vm._v(" "), _c('p', [_c('h-button', {
    staticClass: "link",
    nativeOn: {
      "click": function($event) {
        _vm.goGitbug(_vm.message.github)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")]), _vm._v("  github")])], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-147effde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/index.vue
// module id = 177
// module chunks = 0